import {
  jb_publication_download_overlay_css_default
} from "./chunk.JPNP66E2.js";
import {
  JbOverlay
} from "./chunk.2OWIXINN.js";
import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.WDF6H473.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Animatable
} from "./chunk.B54CNHL3.js";
import {
  recenterNavItems
} from "./chunk.VQ52AZAH.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-publication-download-overlay/jb-publication-download-overlay.ts
var JbPublicationDownloadOverlay = class extends Initiable(Animatable(r)) {
  constructor() {
    super(...arguments);
    this.clickCallbackUrl = "";
    this.noLogo = false;
    this.open = false;
    this.withNewsletterSignup = false;
  }
  render() {
    return ke`
      <div class="publication-download-overlay">
        <jb-publication-download
          class="in-overlay"
          .formAction=${this.formAction}
          .clickCallbackUrl=${this.clickCallbackUrl}
          .features=${this.features}
          .picture=${this.picture}
          .link=${this.link}
          .skipDownloadPage=${this.skipDownloadPage}
          .texts=${this.texts}
          .withNewsletterSignup=${this.withNewsletterSignup}
        ></jb-publication-download>
      </div>
    `;
  }
};
JbPublicationDownloadOverlay.styles = jb_publication_download_overlay_css_default;
__decorateClass([
  n()
], JbPublicationDownloadOverlay.prototype, "clickCallbackUrl", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "features", 2);
__decorateClass([
  n()
], JbPublicationDownloadOverlay.prototype, "formAction", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "link", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "noLogo", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "open", 2);
__decorateClass([
  n({ type: Number })
], JbPublicationDownloadOverlay.prototype, "overlayId", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "picture", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "skipDownloadPage", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "texts", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "withNewsletterSignup", 2);
JbPublicationDownloadOverlay = __decorateClass([
  customElement("jb-publication-download-overlay")
], JbPublicationDownloadOverlay);
bindEvents();

// src/components/jb-publication-download-overlay/jb-publication-download-overlay-controller.ts
var JbPublicationDownloadOverlayController = class {
  constructor() {
    this.overlay = void 0;
    this.publicationOverlay = void 0;
  }
  async close() {
    if (this.publicationOverlay) {
      await this.publicationOverlay.hide();
      enableBodyScroll(this.publicationOverlay);
      recenterNavItems();
    }
    if (this.overlay) {
      this.overlay.unstack();
    }
    this.overlay = void 0;
  }
  open(event) {
    const customEvent = event;
    if (!customEvent.detail.publicationOverlay) {
      return;
    }
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.preventDefault();
    customEvent.detail.clickEvent.stopPropagation();
    this.publicationOverlay = new JbPublicationDownloadOverlay().init({
      props: {
        clickCallbackUrl: customEvent.detail.publicationOverlay.clickCallbackUrl,
        features: customEvent.detail.publicationOverlay.features,
        formAction: customEvent.detail.publicationOverlay.formAction,
        link: customEvent.detail.publicationOverlay.link,
        picture: customEvent.detail.publicationOverlay.picture,
        skipDownloadPage: customEvent.detail.publicationOverlay.skipDownloadPage,
        texts: customEvent.detail.publicationOverlay.texts,
        withNewsletterSignup: customEvent.detail.publicationOverlay.withNewsletterSignup
      }
    });
    this.overlay = new JbOverlay().init({
      props: {
        color: "white",
        hasLogo: false,
        hasCloseIcon: true,
        newAnimation: true,
        returnFocusTo: customEvent.detail.linkTag
      },
      childNodes: [this.publicationOverlay]
    });
    if (this.overlay) {
      this.overlay.stack();
      customElements.whenDefined("jb-publication-download-overlay").then(async () => {
        setTimeout(() => {
          this.publicationOverlay.contentChildren = Array.from(
            this.publicationOverlay.shadowRoot.querySelectorAll(".publication-download-overlay")
          );
        }, 0);
        disableBodyScroll(this.publicationOverlay, { allowTouchMove: () => true });
        recenterNavItems();
        await this.publicationOverlay.reveal();
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        }, 150);
      });
    }
  }
};
var controller = new JbPublicationDownloadOverlayController();
function bindEvents() {
  document.addEventListener("jb-overlay:close", () => {
    controller.close();
  });
  document.addEventListener("jb-link:clicked", (event) => {
    controller.open(event);
  });
}

export {
  bindEvents,
  JbPublicationDownloadOverlay
};
